function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 1.55a6.487 6.487 0 012.5 0c4.08.647 6.83 4.453 6.08 8.42-.5 2.995-2.999 5.343-6.08 5.91-4.082.729-7.997-1.943-8.663-5.91-.666-3.967 2.082-7.692 6.164-8.42zm6.914 6.072c-.583-3.077-3.665-5.1-6.83-4.453-2.249.486-4.081 2.186-4.498 4.453-.583 2.996 1.416 5.991 4.581 6.639 3.082.567 6.164-1.377 6.83-4.453.167-.729.167-1.457-.083-2.186zm-5.83-2.915l.107.009c.28.046.485.27.559.558v3.724l2.832 1.62.077.062c.188.187.237.531.09.747l-.065.075c-.193.183-.547.231-.769.087L7.584 9.808c-.25-.162-.417-.405-.417-.729V5.274l.006-.086c.04-.28.282-.48.66-.48zM12.008.174a.914.914 0 011.072 0l2.582 2.104c.416.324.416.81.166 1.215l-.094.08a.914.914 0 01-1.072 0l-2.665-2.185-.072-.062c-.271-.267-.319-.773-.011-1.072zM3.928.253l.074.082c.333.324.25.89-.083 1.134l-2.5 2.105c-.38.222-.833.24-1.162-.07l-.086-.092c-.25-.324-.25-.81.166-1.134L2.92.173c.303-.22.744-.174 1.009.08z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAlarm;